module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/other-kp/component/other-kp-detail/modal-other-kp-send-adjustment/modal-other-kp-send-adjustment.component.sass
// module id = ./src/app/modules/other-kp/component/other-kp-detail/modal-other-kp-send-adjustment/modal-other-kp-send-adjustment.component.sass
// module chunks = main